module.exports = __webpack_public_path__ + "static/media/light_fixture_console_zku.7efc9a77.png";